import Icon from '../components/Icon.vue'

Icon.register({
  'charging-station': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M336 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-320c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h320zM544 128h16c8.8 0 16 7.2 16 16v32c0 35.8-23.6 65.7-56 75.9v120.1c0 44.4-38.3 80-83.6 75.6-39.5-3.9-68.4-39.3-68.4-79v-24.6c0-22.1-17.9-40-40-40h-8v112h-288v-352c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64v192h8c48.6 0 88 39.4 88 88v28c0 17 15.2 30.5 32.7 27.6 13.8-2.3 23.3-15.2 23.3-29.2v-118.5c-32.4-10.2-56-40.2-56-75.9v-32c0-8.8 7.2-16 16-16h16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48zM260.1 175.8c4.6-7-1.1-15.8-10.4-15.8h-57.7l11.6-50.8c2-6.7-3.7-13.2-11.6-13.2h-68c-6 0-11.1 3.9-11.9 9.1l-16 107c-1 6.3 4.6 11.9 11.9 11.9h59.3l-23 83.1c-1.8 6.6 4 12.9 11.7 12.9 4.2 0 8.2-1.9 10.4-5.2z'
      }
    ]
  }
})
